import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from '../login/login.component';
import { CommonService } from 'src/app/@shared/services/common.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseClass<any> implements OnInit {

  modalRef?: BsModalRef;

  constructor(
    public service: WebserviceService,
    public _common: CommonService,
    private router: Router,
    public _shared: SharedService,
    @Inject(DOCUMENT) public document: Document,
    private modalService: BsModalService
  ) { super(); }

  ngOnInit(): void {
    this.env.isMobile = (window.navigator.userAgent.includes('Mobile')) ? true : false;
    // if(localStorage.getItem(`${this.env.panel}id_token`) && localStorage.getItem(`${this.env.panel}user`)){
    //   this.router.navigate(['/dashboard']);
    // }
    // const head = this.document.getElementsByTagName('head')[0];
    // const style = this.document.createElement('link');
    // style.rel = 'stylesheet';
    // style.href = `assets/css/login.css`;
    // head.appendChild(style);
    this.getData();
    $('.carousel').carousel({
      interval: 3000,
    });
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    let api = this.isLogin() ? this.api.eventListNew : this.api.eventListNewG;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res: ResFormat) => {
        if (res && res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openLogin(e: any) {
    this._common.openModalWithComponent({ login: true }, LoginComponent, 'loginpopup')
  }

  confirmSport(event_id: any) {
    this.router.navigate([`/sports`, event_id]);
  }

  confirmCasino(event_id: any) {
    this.router.navigate([`/casino`, event_id]);
  }

  redirectICasinoLobby(mn_id: any) {
    if (this.isLogin()) {
      this.router.navigate(['/casino', mn_id])
    } else {
      this.openLogin('');
    }
  }

  confirmCasinoDetail1(mn_id: any, game_id: any) {
    if (this.isLogin()) {
      this.router.navigate(['/casino-detail', mn_id, game_id]);
    } else {
      this.openLogin('');
    }
  }

  confirmCasinoDetail(mn_id: any, game_id: any) {
    if (this.isLogin()) {
      let multiplier = 100;
      let msg = `Profit & Loss in iCasino would be ${multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${multiplier}.`;
      // <br> Please note(1 Point = ${multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${multiplier} अंक)
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['/casino-detail', mn_id, game_id]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
    } else {
      this.openLogin('');
    }
  }

  openModal(template: TemplateRef<any>) {

    let cls = 'rulesModaldetail modal-lg';
    let id = 'modal-md';

    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: cls }, { id: id })
    );
  }

}